import * as React from 'react'

import { Theme } from '@mui/material/styles'

import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'

export const styles = {
  content: {
    paddingTop: (theme: Theme) => theme.spacing(0.4),
  },

  searchDetails: {
    fontSize: 14,
    color: '#5f6972',
    lineHeight: '24px',
    marginBottom: (theme: Theme) => theme.spacing(1),
    textAlign: 'center',
  },

  zero: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: 68,
    lineHeight: '68px',
    color: '#5f6972',
    textAlign: 'center',
  },
}

interface Props {
  onAddNewClick: () => void
  searchText: string
}

export const MatchedContactCardZero: React.FC<Props> = (props: Props) => {
  const { onAddNewClick } = props

  return (
    <Card elevation={2}>
      <CardContent sx={styles.content}>
        <Grid container direction="column">
          <Grid item xs={12} sx={styles.zero}>
            0
          </Grid>
          <Grid item xs={12} sx={styles.searchDetails}>
            {props.searchText == ''
              ? 'Search for existing contact or create a new one.'
              : `No Results Found - ${props.searchText}`}
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Button
              variant="outlined"
              color="primary"
              disableElevation
              onClick={onAddNewClick}
              data-test-id="addNewContactBtn"
            >
              Add New Contact
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

MatchedContactCardZero.displayName = 'MatchedContactCardZero'
